var map = {
	"./casos/1.png": 8190,
	"./casos/2.png": 5541,
	"./casos/3.png": 6444,
	"./casos/4.png": 259,
	"./casos/5.png": 9034,
	"./casos/6.png": 9201,
	"./casos/7.png": 4984,
	"./clinica/18A Sala 2.jpg": 3440,
	"./clinica/camilla.jpeg": 7485,
	"./clinica/camilla2.jpeg": 4269,
	"./clinica/entrada.jpeg": 1939,
	"./clinica/entrada2 - copia.jpg": 1923,
	"./clinica/entrada2.jpg": 9246,
	"./clinica/letrero.jpeg": 3115,
	"./clinica/material.jpeg": 7309,
	"./clinica/mesa.jpeg": 3826,
	"./clinica/puertabaño.jpeg": 286,
	"./equipo/1carnet.png": 3995,
	"./equipo/2.jpeg": 3268,
	"./equipo/2carnet.png": 6056,
	"./equipo/3.jpeg": 5435,
	"./equipo/3carnet.jpg": 177,
	"./equipo/equipofull.jpeg": 6450,
	"./equipo/equipofullmid.png": 9107,
	"./formacion/formacion1.JPG": 7676,
	"./formacion/formacion2.JPG": 7595,
	"./formacion/formacion3.JPG": 7278,
	"./formacion/formacion4.JPG": 2021,
	"./formacion/formacion5.JPG": 5336,
	"./formacion/formacion6.jpeg": 7567,
	"./green-1846861_1280.png": 2747,
	"./home_image.jpg": 1744,
	"./horario.png": 3741,
	"./icon/arrow-down.png": 1825,
	"./icon/mail-blanco.png": 238,
	"./icon/mail.png": 6592,
	"./icon/telefono-blanco.png": 6617,
	"./icon/telefono.png": 2609,
	"./icon/ubicacion-blanco.png": 1994,
	"./icon/ubicacion.png": 3668,
	"./icon/up-arrow.png": 3538,
	"./icon/ytb.png": 3774,
	"./logo_szience.PNG": 8887,
	"./logoblanco.png": 2791,
	"./logonegro.png": 7011,
	"./manos_gris.png": 6561,
	"./manos_naranja.png": 8037,
	"./tarifas/Tarifas2022FisioPinseque.pdf": 5310,
	"./tarifas/ejdir.jpeg": 8613,
	"./tarifas/fisio.jpeg": 4941,
	"./terapias/eco.png": 7670,
	"./terapias/ejterapeutico.jpg": 1209,
	"./terapias/fibrolisis.jpg": 7023,
	"./terapias/manual.jpg": 9159,
	"./terapias/mckenzie.jpg": 8519,
	"./terapias/mujer.jpg": 548,
	"./terapias/puncion.jpg": 3191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;